module.exports = "/_next/static/images/texas-fae5ac1387b9f308c143349090eab46a.svg";